import { Component, OnInit } from '@angular/core';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import * as moment from 'moment';
import {
  BackendService,
  NotificationService,
  TableSettings,
  FieldStructure,
  ListService,
  FieldMapItem,
} from 'beyond-util';
import { ReportService } from '../../../services/report.service';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { IzvestajSettings } from '../prihodi-po-emisijama/izvestaj-settings.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { UtilServiceClient } from '../../../services/util.service';
import { RequestTypeEnum } from '../../../enums/request-type.enum';

@Component({
  selector: 'app-izvestaj-za-ofps',
  templateUrl: './izvestaj-za-ofps.component.html',
  styleUrls: ['./izvestaj-za-ofps.component.scss'],
})
export class IzvestajZaOfpsComponent extends IzvestajBaseComponent
  implements OnInit {
  public canGenerate = true;

  constructor(
    protected _backendService: BackendService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService);
    this._spinner.show();
    this.getSettings();
    this.name = 'Izveštaj za OFPS';
  }

  ngOnInit() {
    setTimeout(() => {
      super.ngOnInit();
      this.orderList = [];
      this.report = {
        DatumOd: new Date(),
        DatumDo: new Date(),
        ProgramIds: [],
      };
    });
  }

  fetchProgrami() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .subscribe(response => {
        const programi = response.ServiceData.Data;
        const parsed = this.utilService.parseEnum(programi);
        this._listService.registerEnum('MSIZV_OFPS_ProgramIdsEnum', parsed);
        this._spinner.hide();
      });
  }

  getSettings() {
    const req = this.reportService.getSettingsPayload(
      ReportNameEnum.OFPS,
      EndpointTypeEnum.Settings,
      FormCode.MSIZV_OFPS
    );

    this.reportService.getSettings(req).subscribe(s => {
      this.splitDetails(s);
      this.fetchProgrami();
      this._listService.enumItemsSet.subscribe(prog => {
        this.fieldStructure = new FieldStructure(s, 'header');
        this.settingsTable = new TableSettings(s.details[0], 'table');
        this.settingsTableSource.next(this.settingsTable);
        this._spinner.hide();
      });
    });
    this._spinner.hide();
  }

  onReportValueChanged(event) {
    if (event) {
      switch (event.fieldMap.fieldKey) {
        case 'DatumOd':
        case 'DatumDo':
        case 'ProgramIds':
          this.canGenerate = false;
          break;
      }
    }
  }

  refresh() {
    this.report = {
      DatumOd: new Date(),
      DatumDo: new Date(),
      ProgramIds: [],
    };

    this.orderList = [];
    this.documentListSource.next(this.orderList);
  }

  settingsLoadSingle() {}

  getFilterString(): string {
    return `?datumOd=${moment(this.report.DatumOd).format(
      DEFAULT_DATE_FORMAT
    )}&datumDo=${moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT)}`;
  }

  filter() {
    if (this.report.ProgramIds && this.report.ProgramIds.length < 1) {
      this.notificationService.notyError(
        'Potrebno je odabrati bar jedan program.'
      );

      return;
    }

    if (moment(this.report.DatumOd).isAfter(moment(this.report.DatumDo))) {
      this.notificationService.notyError('Zadati period datuma nije validan.');

      return;
    }

    const entity = {
      DatumOd: moment(this.report.DatumOd).format(DEFAULT_DATE_FORMAT),
      DatumDo: moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT),
      ProgramIds: this.report.ProgramIds,
    };

    this._spinner.show();
    this.reportService
      .getFormData(
        this.reportService.getPayload(
          '',
          entity,
          FormCode.MSIZV_OFPS,
          ReportNameEnum.OFPS,
          EndpointTypeEnum.Form,
          RequestTypeEnum.Post
        )
      )
      .subscribe((data: any) => {
        this._spinner.hide();
        this.orderList = this.getResponseData(data);
        if (!(this.orderList.length > 0)) {
          this.notificationService.notyError(
            'Ne postoji ni jedna verifikovana stavka za zadati period datuma.'
          );

          this.canGenerate = false;
        } else {
          this.canGenerate = true;
        }
        this.documentListSource.next(this.orderList);
      });
  }

  getExcelFileName() {
    const formattedDate: string = `${moment(new Date()).format(
      'YYYY-MM-DD_HH:mm'
    )}`.replace(
      `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
      '-'
    );
    const fileName = `Izveštaj_za_OFPS_${formattedDate}`;

    return fileName;
  }

  onToolbarActionExport() {
    if (!this.orderList.length) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const payload = this.reportService.getPayload(
      this.getFilterString(),
      this.orderList,
      FormCode.MSIZV_OFPS,
      ReportNameEnum.OFPS,
      EndpointTypeEnum.Xls
    );

    this.reportService.exportToDocument(payload).subscribe(xlsx => {
      ReportService.downloadBlob(
        xlsx,
        MimeFileType.Xlsx,
        this.getExcelFileName()
      );
    });
  }

  onToolbarActionPrint() {
    if (!this.orderList.length) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const payload = this.reportService.getPayload(
      this.getFilterString(),
      this.orderList,
      FormCode.MSIZV_OFPS,
      ReportNameEnum.OFPS,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(payload).subscribe(pdf => {
      ReportService.openBlob(pdf, MimeFileType.Pdf);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-za-ofps/izvestaj-za-ofps.component.ts